import { Fragment, type MouseEvent } from 'react';
import { X } from 'react-feather';
import type { ToastContentProps } from 'react-toastify';

type TToastMessageProps = {
  title?: string;
  message: string;
  closeToast?: ToastContentProps['closeToast'];
};

const DEFAULT_ERROR_MESSAGE = 'خطایی رخ داده است لطفا بعدا تلاش کنید';

export const ToastMsg = ({ title, message, closeToast }: TToastMessageProps) => {
  const cleanedMessage = message?.trim();
  const finalMessage = cleanedMessage ? cleanedMessage : DEFAULT_ERROR_MESSAGE;

  const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    closeToast?.(true);
  };

  return title ? (
    <div
      data-testid='toast-message'
      className='flex-col items-start whitespace-nowrap overflow-hidden text-ellipsis'
    >
      <div className='flex justify-between items-start'>
        <h2 className='font-bold mb-2 whitespace-nowrap overflow-hidden text-ellipsis'>{title}</h2>

        <button type='button' className='p-1 hover:bg-hover rounded-md mb-1' onClick={handleClose}>
          <X width={18} height={18} strokeWidth={'1'} />
        </button>
      </div>

      <p className='whitespace-nowrap overflow-hidden text-ellipsis mb-[15px]'>{finalMessage}</p>
    </div>
  ) : (
    <div data-testid='toast-message' className='flex justify-between items-center '>
      <p className='whitespace-wrap overflow-hidden text-wrap text-ellipsis max-w-[700px]'>
        {finalMessage.split('\n').map((item, index) => (
          <Fragment key={index}>
            <span>{item}</span>
            <br />
          </Fragment>
        ))}
      </p>

      <button
        type='button'
        className='hover:bg-hover rounded-md mr-2 w-[26px] flex items-center justify-center '
        onClick={handleClose}
      >
        <X width={18} height={18} strokeWidth={'1'} className='m-1' />
      </button>
    </div>
  );
};
